import { z } from 'zod'
import { oc } from '@orpc/contract'
import { pageSchema } from '../../utils/page.contract'
import { recordQuerySchema } from '../../utils/record-query.contract'
import { cpgAuditEntrySchema } from './cpg-registry.contract'

/** Filterable/sortable columns of the audit table. */
export const CPG_AUDIT_QUERY_FIELDS = [
  'id',
  'actor',
  'entityType',
  'entityId',
  'action',
  'createdAt',
] as const

/** Read-only view over the append-only cpg_registry_audit trail; newest first by default. */
export const listCpgAudit = oc
  .route({ method: 'POST', path: '/v2/cpg/audit/list' })
  .input(recordQuerySchema(CPG_AUDIT_QUERY_FIELDS))
  .output(z.object({ page: pageSchema, data: z.array(cpgAuditEntrySchema) }))
